import PersonService from "../../Services/Person.service";
let cachedCurrentPersonPromise = null;
/**
 * This hook provides the current person, but only loads it once per application initialization to save
 * on HTTP requests and time.
 */
const getCurrentPersonInfo = () => {
    if (!cachedCurrentPersonPromise) {
        cachedCurrentPersonPromise = PersonService.loadCurrentPersonInfo();
    }
    return cachedCurrentPersonPromise;
};
const useCachedLoadCurrentPersonInfo = () => getCurrentPersonInfo;
export default useCachedLoadCurrentPersonInfo;
